import React, { useState } from "react";

const Preferences = () => {
  const [currency, setCurrency] = useState("Rs. Indian rupee");
  const [language, setLanguage] = useState("English");
  const [accessibilityRequirements, setAccessibilityRequirements] = useState(
    "Filter out properties that don’t meet your needs"
  );
  const [isAccessibilityRequirementsEditable, setIsAccessibilityRequirementsEditable] = useState(false);


  const handleCurrencyChange = (e) => {
    setCurrency(e.target.value);
  };

  const handleLanguageChange = (e) => {
    setLanguage(e.target.value);
  };

  const handleAccessibilityRequirementsChange = (e) => {
    setAccessibilityRequirements(e.target.value);
  };

  const handleSave = () => {
    // Save the preferences to the server
  };

  return (
    <div className="p-4">
      <h2 className="font-bold text-gray-700 text-lg mb-4">Preferences</h2>
      <div className="mb-4">
        <h3 className="font-bold text-gray-700 text-md mb-2">Currency</h3>
        <p className="text-gray-500 text-sm">{currency}</p>
        <button
          className="text-blue-500 hover:text-blue-700 text-sm"
          onClick={() => setCurrency("")}
        >
          Edit
        </button>
        {currency === "" && (
          <div className="mt-2">
            <input
              className="w-full border-gray-300 rounded-md shadow-sm mb-2"
              type="text"
              placeholder="Enter currency"
              value={currency}
              onChange={handleCurrencyChange}
            />
            <button
              className="text-white bg-black hover:scale-[1.05] transition-all font-bold py-2 px-4 rounded"
              onClick={handleSave}
            >
              Save
            </button>
            <button
              className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded ml-2"
              onClick={() => setCurrency("Rs. Indian rupee")}
            >
              Cancel
            </button>
          </div>
        )}
      </div>
      <div className="mb-4">
        <h3 className="font-bold text-gray-700 text-md mb-2">Language</h3>
        <p className="text-gray-500 text-sm">{language}</p>
        <button
          className="text-blue-500 hover:text-blue-700 text-sm"
          onClick={() => setLanguage("")}
        >
          Edit
        </button>
        {language === "" && (
          <div className="mt-2">
            <input
              className="w-full border-gray-300 rounded-md shadow-sm mb-2"
              type="text"
              placeholder="Enter language"
              value={language}
              onChange={handleLanguageChange}
            />
            <button
              className="text-white bg-black hover:scale-[1.05] transition-all font-bold py-2 px-4 rounded"
              onClick={handleSave}
            >
              Save
            </button>
            <button
              className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded ml-2"
              onClick={() => setLanguage("English")}
            >
              Cancel
            </button>
          </div>
        )}
      </div>
      <div className="mb-4">
        <h3 className="font-bold text-gray-700 text-md mb-2">
          Accessibility requirements
        </h3>
        <p className="text-gray-500 text-sm">{accessibilityRequirements}</p>
        <button
          className="text-blue-500 hover:text-blue-700 text-sm"
          onClick={() => setIsAccessibilityRequirementsEditable(true)}
          >
          Edit
          </button>
          {isAccessibilityRequirementsEditable && (
          <div className="mt-2">
          <textarea
          className="w-full border-gray-300 rounded-md shadow-sm mb-2"
          rows="4"
          placeholder="Enter your accessibility requirements"
          value={accessibilityRequirements}
          onChange={(e) => setAccessibilityRequirements(e.target.value)}
          />
          <div className="flex justify-end">
          <button
          className="text-gray-500 hover:text-gray-700 mr-2"
          onClick={() => setIsAccessibilityRequirementsEditable(false)}
          >
          Cancel
          </button>
          <button
          className="text-white bg-black hover:scale-[1.05] transition-all font-bold py-2 px-4 rounded"
          onClick={() => setIsAccessibilityRequirementsEditable(false)}
          >
          Save
          </button>
          </div>
          </div>
          )}
          </div>
          </div>
          );
          };
          
          export default Preferences;
          
          
          
          
          
